import { Box, Container, Stack } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import SearchIcon from "@mui/icons-material/Search";
import { useEffect, useState } from "react";
import WCDTextField from "../ui/WCDTextField";
import { useSearchParams } from "react-router-dom";
import WCDButton from "../ui/WCDButton";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Filters from "../components/Filters";

const SearchBar = ({ onSearch }) => {
  const [keywords, setKeywords] = useState("");
  const [zipCode, setZipCode] = useState("");

  const [searchParams, setSearchParams] = useSearchParams();
  const [showFilters, setShowFilter] = useState(false);

  useEffect(() => {
    const zip_code = searchParams.get("zip_code");
    if (zip_code) {
      setZipCode(zip_code);
    }

    const key_words = searchParams.get("keywords");
    if (key_words) {
      setKeywords(key_words);
    }
  }, []);

  const onClickSearchHandler = () => {
    setSearchParams({
      ...Object.fromEntries(searchParams),
      keywords: keywords,
      zip_code: zipCode,
    });

    onSearch();
  };

  const onFilterClickHandler = () => {
    setShowFilter((prev) => !prev);
  };

  const closeFiltersHandler = () => {
    setShowFilter(false);
  };

  return (
    <Box
      sx={{
        backgroundColor: "#0B3C65",
        borderRadius: "25px",
        // height: "190px",
        padding: { xs: "30px", sm: "45px" },
        paddingBottom: { xs: "30px", sm: "35px" },
      }}
    >
      <Container maxWidth="md">
        <Stack spacing={2}>
          <Grid container spacing={2}>
            <Grid xs={12} sm={6} md={5}>
              <WCDTextField
                sx={{ fontSize: { xs: "0.85rem", sm: "1rem" } }}
                id="search"
                label="Location, Doctor Name"
                variant="outlined"
                fullWidth
                placeholder="Doctor Name,Procedure,..."
                size="small"
                value={keywords}
                onChange={(event) => {
                  setKeywords(event.target.value);
                }}
              />
            </Grid>
            <Grid xs={12} sm={6} md={3}>
              <WCDTextField
                id="zip-code"
                label="Zip code"
                variant="outlined"
                fullWidth
                placeholder="Zip code"
                size="small"
                sx={{
                  borderRadius: "25px",
                  backgroundColor: "#ffff",
                  fontSize: { xs: "0.85rem", sm: "1rem" },
                }}
                value={zipCode}
                onChange={(event) => {
                  setZipCode(event.target.value);
                }}
              />
            </Grid>
            <Grid xs={12} sm={12} md={2}>
              <WCDButton
                text="Search"
                startIcon={<SearchIcon />}
                onClick={onClickSearchHandler}
              />
            </Grid>
            <Grid xs={12} sm={12} md={2}>
              <WCDButton
                text="Filter"
                startIcon={<FilterAltIcon />}
                onClick={onFilterClickHandler}
              />
            </Grid>
          </Grid>
          <Filters open={showFilters} onClose={closeFiltersHandler} />
        </Stack>
      </Container>
    </Box>
  );
};

export default SearchBar;
